import {constantTrue, constantFalse} from '@packages/utilities/fp/utils';
import {type ResultType, match} from './Type';

export const isError: (arg1: ResultType<any, any>) => boolean = match({
  Error: constantTrue,
  Ok: constantFalse,
});

export const isOk: (arg1: ResultType<any, any>) => boolean = match({
  Error: constantFalse,
  Ok: constantTrue,
});
